module.exports = __webpack_public_path__ + "img/acessGrey.37f1635b.svg";